import { login } from './login';
import { password } from './password';
import { iptelmex } from './iptelmex';
import { register } from './register';

const Auth = {
  login,
  password,
  iptelmex,
  register
};

export { Auth };



// WEBPACK FOOTER //
// ./src/AAF/Auth/main.js